import { Api, Config } from './api'

export const ApiObterAtividades = async (filtros) => {
   const params = new URLSearchParams()

   if (filtros.pagina) {
      params.append('pagina', filtros.pagina)
   }

   if (filtros.limite) {
      params.append('limite', filtros.limite)
   }
   if (filtros.matricula) {
      params.append('matricula', filtros.matricula)
   }

   if (filtros.id) {
      params.append('contratoId', filtros.id)
   }

   if (filtros.email) {
      params.append('email', filtros.email)
   }

   if (filtros.dataInicio) {
      params.append('dataInicio', filtros.dataInicio)
   }

   if (filtros.dataFim) {
      params.append('dataFim', filtros.dataFim)
   }

   const { data } = await Api.get(`/atividade/consolidada`, Config(params))

   return data
}

export const ApiObterAtividadesDetalhes = async (filtros) => {
   const params = new URLSearchParams()

   if (filtros.pagina) {
      params.append('pagina', filtros.pagina)
   }

   if (filtros.limite) {
      params.append('limite', filtros.limite)
   }
   if (filtros.matricula) {
      params.append('matricula', filtros.matricula)
   }

   if (filtros.escalaId) {
      params.append('escalaId', filtros.escalaId)
   }

   const { data } = await Api.get(`/atividade`, Config(params))

   return data
}

export const ApiObterAtividadesTipo = async (filtros) => {
   const params = new URLSearchParams()

   if (filtros.pagina) {
      params.append('pagina', filtros.pagina)
   }

   if (filtros.limite) {
      params.append('limite', filtros.limite)
   }
   if (filtros.descricao) {
      params.append('descricao', filtros.descricao)
   }
   const { data } = await Api.get(`/atividade-tipo`, Config(params))

   return data
}

export const ApiRegistrarAtividade = async (payload) => {
   const { data } = await Api.post(`/atividade`, payload, Config())

   return data
}
export const ApiObterEscala = async (idEscala) => {
   const { data } = await Api.get(`/escala/${idEscala}`, Config())

   return data
}
export const ApiObterAtividadePorId = async (id) => {
   const { data } = await Api.get(`/atividade/${id}`, Config())
   return data
}

export const ApiEditarAtividade = async (payload) => {
   const { data } = await Api.put(`/atividade/${payload.id}`, payload.body, Config())

   return data
}

export const ApiDesconsiderarAtividade = async (payload) => {
   const { data } = await Api.put(`/atividade/${payload.id}/desconsiderar`, { observacoes: payload.observacao }, Config())      
   return data
}
